app.controller("AddAdminController", ["$scope", "$uibModalInstance", "Users", "Administrators", "StaticData", "ProgramService", "toastr",
    function ($scope, $uibModalInstance, Users, Administrators, StaticData, ProgramService, toastr) {
        $scope.chosenFaculties = {};

        $scope.getUsers = function (name) {
            if (name.length < 1) {
                return [];
            }
            return Users.list({
                query: name
            }).then(function (data) {
                return data.docs;
            });
        };

        StaticData.getItemsByKey("faculties").then(function (faculties) {
            $scope.faculties = faculties;
            $scope.facultiesMap = _.keyBy($scope.faculties, '_id');
        });

        $scope.create = function () {
            var admin = {};
            admin.info = {};
            admin.user = $scope.chosenUser._id;
            admin.info.faculties = _($scope.chosenFaculties).pickBy(function (value) {
                return value;
            }).keys().value();
            Administrators.add(admin).then(function () {
                $uibModalInstance.close();
            }).catch(function (err) {
                if (err.status == 400) {
                    toastr.error('', 'მიმდინარე მომხმარებელს უკვე აქვს ადმინისტრატორის აქტიური პროფილი.');
                }
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);